import React, { useEffect, useState, useRef } from 'react';
import { Buttons } from '../../../../Common/fCore/fButtons';
import { KeyValueDetails } from '../../../../Common/fCore/fKeyValue';
import { Owner } from '../../../../Common/fCore/fOwner';
import { Status } from '../../../../Common/fCore/fStatus';
import { FloatInputButton } from '../../../../Common/fInputs';
import { get, post } from '../../../../../Model/Network/Config/Axios';
import { handleError, showToast } from '../../../../Common/fToast/ToastCallback';
import Tds from './Tds';
import { numberWithCommas } from '../../../../../Utils/NumberToComma';
import CustomTags from '../../../fCommon/CustomTags/CustomTags';
import FileCard from '../../../../Common/FileCards/FileCard';
import { StateButton } from '../../../../Common/fStateButton';
import SelectGST from '../../../../Common/fUtils/SelectGST';
import { useSelector } from 'react-redux';
import { Modal } from '../../../../Common/fModal/Modal';
import { FunctionalInput } from '../../../../Common/fInputs';
import { Select } from '../../../../Common/Class/Select';
import Spinner from "react-spinner-material";
import { separateCamelCase } from '../../../../../Utils/Utils';
import { VirtualAccountToggle } from '../../../../Common/VirtualAccountToggle';

export const displayKeyMap = {
	"Budget Code": "Budget code",
	"Select Location": "Location",
	"Select Business": "Business",
	"Select Cost center": "Cost Center",
	"Service From": "Service from",
	"Service To": "Service to",
	"Advance GL Code": "Advance GL Code",
	"Select Department": "Department",
	"Select GST tagging": "GST tagging",
	"Nature Of Expense": "Nature Of Expense"
};

export const customOrder = [
	"Budget Code",
	"Select Location",
	"Select Business",
	"Select Cost center",
	"Service From",
	"Service To",
	"Advance GL Code",
	"Select Department",
	"Select GST tagging",
	"Nature Of Expense"
];

const Index = ({categoriesMapping,data,pending,buttons,reload,id,loading}) => {
	const [recall,setRecall] = useState(false);
	const [defaultBank,setDefaultBank] = useState(undefined);
	const [allBanks,setAllBanks] = useState([]);
	const [updatedBank,setUpdatedBank] = useState({
		label: 'Select Bank',
		value: undefined
	});
	const [updatedRemarks,setUpdatedRemarks] = useState(undefined)
	const [showUpdateBank,setShowUpdateBank] = useState(false);
	const REMARKS1 = useRef(null);
	const [loadingSpiner,setLoadingSpiner] = useState(false);
	const [virtualToggles, setVirtualToggles] = useState(false);
	const {verifyOnBankDetailsUpdateByAdmin,tdsRoundOffNextInteger} = useSelector(state => state.auth.config.plugins);

	const update = (key, value,isForm) => {
		let  data = {}
		if (isForm) {
			data = {
			   key,
			   value
			};
		} else {
			data[key] = value;
		}
		post(`vendor/advances/${id}/update`,data, (e, r) => {
			if (r) {
				reload()
				showToast({
					type: 'success',
					message: 'Field Updated'
				})
			} else if (e) {
				handleError(e);
			}
		});
	}

	const [advanceAmt,setAdvanceAmt] = useState();
	const [show,setShow]=useState(false);
	const tenant = useSelector(state=>state.auth.config.tenant)

	const keyValueMap = {};
	data.forms.forEach(item => {
		keyValueMap[item.key] = item.value;
	});
	
	let categoryName="-";
	if(data && !data.categoryName && data.categoryId){
		categoryName=categoriesMapping[data.categoryId];
	}

	useEffect(()=>{
		if(data){
			let tdsAmount=0;
			if(data.tds && data.tds.tds){
				tdsAmount=data.tds.tds*(data.content.baseAmount)/100;				
			}else{
				tdsAmount=data.content.tds || 0;	
			}
			setAdvanceAmt(data.amount-Number(tdsAmount))
		}
	},[data])

	useEffect(()=>{
		if(data && data.vendor && data.vendor.id){
		get(`/vendor/contacts/${data.vendor.id}/banks`,(e,r) =>{
			if(r&& r.defaultBank){
				setDefaultBank(r.defaultBank)
			}
			if(r && r.allBanks && r.allBanks.length>0){
				let allBanksData = [];
				r.allBanks.forEach(item => {
					allBanksData.push({
						ifsc: item.ifsc,
						bankName: item.bankName,
						account: item.account,
						accountId: item.accountId
					})
				});
				setAllBanks(allBanksData);
			}
		})
		}
	},[data])


	const approvalStatus= (bothShow=false) =>{
		const status = data && data.status
		const showTenantOnlyAtTaxation = ['ANRCK','ANAROCK','MOGLIXUAT']
		  if(showTenantOnlyAtTaxation.includes(tenant) && !bothShow){
		   return status === 'TAXATION_APPROVAL'
		}
		 if(status === 'APPROVAL'){
			 return true
		 }
		 else if(status === 'TAXATION_APPROVAL'){
			 return true
		 }
		 return false
   }

	
	// Sort forms by custom order, unknown keys go last
	const sortedForms = data.forms
		? [...data.forms]
			.sort((a, b) => {
				const aIndex = customOrder.indexOf(a.key);
				const bIndex = customOrder.indexOf(b.key);
				if (aIndex === -1 && bIndex === -1) return 0;
				if (aIndex === -1) return 1;
				if (bIndex === -1) return -1;
				return aIndex - bIndex;
			})
			.map(item => ({
				...item,
				key: displayKeyMap[item.key] || item.key
			}))
		: [];

    return(
        <div>
			{
				data.status === "COMPLETED" && !(data.attrs["settled.time"]) &&
				<p style={{
					color: 'var(--white-color)',
					fontSize: 14,
					background: 'var(--red-color)',
					padding: "5px 12px",
					borderRadius: 4,
					cursor: 'pointer',
					position: 'absolute',
					right: 100,
					top: 30
				}} onClick={() => setRecall(true)}>
					Recall
				</p>

			}
            
            <Status badges={[
				{
					title:`Status : ${data.status}`,
					background:'var(--primary-color)'
				},
				{
					title:`Amount : INR ${data.amount}`,
					background:"var(--green-color)"
				}
			]}/>
             {
                pending ?
				(loading 
				? <StateButton/>
                : <Buttons buttons={buttons} />)
                :null
             }

             <Owner owner={data.owner} />
			 {
				defaultBank &&
				<>
					<div style={{position: 'relative'}}>
						<KeyValueDetails header={'Default Bank Details'} 
						values={[
							{
								key: 'Bank Name',
								value: defaultBank.bankName || '-'
							},
							{
								key: 'Account Number',
								value: defaultBank.account || '-'
							},
							{
								key: 'IFSC Code',
								value: defaultBank.ifsc || '-'
							}
						]}/>
						<button className='btn btn-portlet' onClick={()=>setShowUpdateBank(true)} style={{
							width: 'fit-content',
							marginTop:0,
							position: 'absolute',
							right: 0,
							top: 10,
							fontSize: 12,
						}}>update bank</button>
					</div>
				</>
			 }
             <div style={{fontSize: '14px', fontWeight: 'bold',margin: '30px 0px 10px 0px'}}>PO Details</div>

            
            {
            data.po?
            <>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>PO Number:</span> {data.po.poNo}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Remarks:</span> {data.remarks}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Vendor Name:</span> {data.vendor.name}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Vendor Gstin:</span> {data.vendor.gstin}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Vendor Registered Id:</span> {data.vendor.registeredId}</div>
            </>
            :<div style={{padding: '20px', border: '1px solid var(--border-color)', borderRadius: '6px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>No Information available</div>
            }
            <KeyValueDetails header="Advance Details" values={[
				{
					key:'Advance Id',
					value:data.advanceId
				},
                {
					key:'Base Amount',
					value:(data && data.content && data.content.baseAmount) ? numberWithCommas(data.content.baseAmount) :0
				},
				{
					key:'Tax %',
					value:(data && data.content && data.content.taxSlab) ? data.content.taxSlab :0
				},
                {
					key:'Tax Amount',
					value:(data && data.content && data.content.taxAmount) ? numberWithCommas(data.content.taxAmount) :0
				},
				{
					key:'Tds',
					value:numberWithCommas(data.tds ? (tdsRoundOffNextInteger ? Math.ceil(data.tds.tds*data.content.baseAmount/100) : data.tds.tds*data.content.baseAmount/100) : (data.content.tds || 0))
				},
				{
					key:'Tds Section',
					value:`${ data.tds ? data.tds.code :(data.content.tdsCode?data.content.tdsCode:'-')}`
				},
				{
					key:'Tds Description',
					value:`${data.tds ? data.tds.description :(data.content.tdsDesc?data.content.tdsDesc:'-')}`
				},
				{
					key:'Tds Slab',
					value:`${data.tds ? data.tds.tds  : (data.content.tdsSlab)}`
				},
				{
					key:'Category',
					value:`${data.categoryName ? data.categoryName :categoryName}`
				},
				{
					key:'Remarks',
					value:`${data.remarks ? data.remarks :'-'}`
				},
				{
					key:'Advance Amount',
					value:numberWithCommas(advanceAmt)
				},
				{
					key:'Office',
					value:data.office?data.office:'-'
				},
				{
					key:'UTR No',
					value:(data.attrs && data.attrs.utr)?data.attrs.utr:'-'
				}
				
			]}/>
            <div style={{fontSize: '14px', fontWeight: 'bold',margin: '30px 0px 10px 0px'}}>Advance Details</div>            
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Advance Id:</span> {data.advanceId}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Advance Amount:</span> {numberWithCommas(advanceAmt)}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Tds Slab</span> {data.tds ?data.tds.tds: (data.content?data.content.tdsSlab:'-')}</div>
            <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>Tds description:</span> {data.tds ?data.tds.description: (data.content?data.content.tdsDesc:'-')}</div>   
			{
				data.attrs && Object.keys(data.attrs || {}).length > 0 ?
				Object.entries(data.attrs).map(([key,value])=>{
					return <div style={{marginTop: '5px'}}><span style={{color: '#666', marginRight: '3px'}}>{separateCamelCase(key)}:</span> {value}</div>
				}) 
				:null
			} 
			{data && approvalStatus() ?
				<>	
					<div style={{marginTop:10}}><strong>Update Details</strong></div>
					<div style={{ display: 'flex' }}>
						<div style={{ width: '50%' }}>
							<FloatInputButton
								onSubmit={(val) => {
									update('base', Number(val))
								}} title='Base Amount '
								placeholder={(data && data.content && data.content.baseAmount) ? data.content.baseAmount : 0}
								disabled={!approvalStatus()}
							/>
						</div>
						<div style={{ width: '50%', paddingLeft: '10px', marginTop: 20 }}>
							<Tds id={id} value={data.tds ? (tdsRoundOffNextInteger ? Math.ceil(data.tds.tds*data.content.baseAmount/100) : data.tds.tds*data.content.baseAmount/100) :(data.content.tds ? data.content.tds : 0)}
								vendorId={data.vendor && data.vendor.id}
								init={() => {
									reload()
								}}
								disabled={!approvalStatus()}
								vendor={(data && data.vendor?data.vendor:undefined)}
							/>
						</div>
					</div>
					<div style={{ display: 'flex' }}>
						<div style={{ width: '50%' }}>
							<FloatInputButton
								onSubmit={(val) => {
									update('amount', Number(val))
								}} title='Advance Amount '
								placeholder={numberWithCommas(advanceAmt)}
								disabled={!approvalStatus()}
							/>
						</div>
						<div style={{ width: '50%', paddingLeft: '10px', marginTop: 5 }}>
							<SelectGST defaultValue={(data && data.content && data.content.taxSlab) ? { label: `${data.content.taxSlab}`, value: `${data.content.taxSlab}` } 
								:
								{ label: `0`, value: `0` }
							   } placeholder="Select Gst (%)" onSelect={(val) => {
								update('taxSlab', Number(val.value))
							}}/>
						</div>
					</div>
					{
						data.forms && data.forms.length > 0 ?
							<>
								<div><strong>Forms</strong></div>
								{data.forms.map((item, index) => {
									return (
										<FloatInputButton
											onSubmit={(val) => {
												update(item.id, val, true)
											}}
											title={item.key}
											placeholder={item.value || '-'}
											disabled={!approvalStatus()}
										/>
									)
								})}
							</>
							: undefined
					}
				</>
				: null
			}
			{
				data.forms.length && tenant === 'BSETEST'
					? <KeyValueDetails header="Custom Details" values={sortedForms} />
					: data.forms.length && <KeyValueDetails header="Custom Details" values={data.forms} />
			}

			{
				(data.content.attachments && data.content.attachments.length>0)? 
					<div>
						<div
							style={{fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 15px 0px'}}>Attachments
						</div>
						<div style={{
							display: 'flex',
							marginLeft: '-15px',
							flexWrap: 'wrap',
							maxHeight: '250px',
							overflowY: 'scroll'
						}}>
							{
								data.content.attachments.map((file,index) => {
									return (
										<FileCard
											data={{
												title:`${index+1}) ${file.path.slice(0,20)}${file.path.length>20 ? '...' :''}`,
												path:file.path
											}}
										/>
									)
								})
							}
						</div>
					</div>	:null	
			}
			<div style={{border:'1px solid var(--border-color)',padding:12,borderRadius:12,marginTop:20,paddingTop:10}}>
				<div style={{'display':'flex','justifyContent':'space-between'}}>
					<div onClick={() => {setShow((!show))}} style={{fontSize: '14px', fontWeight: 'bold', cursor:'pointer'}}>Custom Tags</div>
					<div style={{'border':'1px solid black', 'borderRadius':'100%', width:'18px',height:'18px','display':'flex','justifyContent':'center', 'alignItems':'center',cursor:'pointer'}} onClick={() => {setShow((!show))}}>
						<img style={{width:12,transform:!show?'rotate(0deg)':'rotate(180deg)'}} src={require('../../../fCommon/ViewCreditNote/India/down.png')} alt="down"/>
					</div> 
				</div>
				{(show)?<div style={{marginLeft:'1rem'}}>
					<CustomTags title={"Vendor Custom Tags"} data={(data && data.vendor && data.vendor.customTags)?data.vendor.customTags:{}}/>
				</div>:null}
			</div>
			<Modal
				title='Recall Advance'
				des="Enter a reason to recall advance"
				close={() => {
					setRecall(false)
				}}
				show={recall}
				onSave={() => {
					let remarks = REMARKS1.current.value;
					if (!remarks) {
						showToast({
							type: 'error',
							message: "Please enter the remarks"
						})
						return;
					}

					let data = {
						remarks
					}
					post(`vendor/advances/${id}/settled/recall`, { ...data }, (e, r) => {
						if (r) {
							setRecall(false)
							reload()
							showToast({
								type: 'success',
								message: "Advance Recalled  successfully"
							})
						} else {
							handleError(e)
						}
					})

				}}
			>
				<FunctionalInput type="text" title="Remarks" ref={REMARKS1} />

			</Modal>
			<Modal
				title='Update Bank Details'
				des="Update the bank details for this advance"
				close={() => {
					if(loadingSpiner)
					{
						showToast({
							type: 'error',
							message: "Please wait, bank details are being varified"
						})
						return;
					}
					setShowUpdateBank(false)
					setUpdatedBank({
						label: 'Select Bank',
						value: undefined
					})
					setUpdatedRemarks(undefined)
				}}
				show={showUpdateBank}
				onSave={()=>{
					if(!updatedBank.value)
					{
						showToast({
							type: 'error',
							message: "Please select a bank"
						})
						return;
					}
					if(!updatedRemarks)
					{
						showToast({
							type: 'error',
							message: "Please enter remarks"
						})
						return;
					}
					post(`vendor/contacts/${data.vendor.id}/bank/${updatedBank.value.accountId}/update`, {
						ifsc: updatedBank.value.ifsc,
						account: updatedBank.value.account,
						banckName: updatedBank.value.bankName,
						remarks: updatedRemarks,
					}, (e, r) => {
						if (r) {
							setShowUpdateBank(false)
							setUpdatedBank({
								label: 'Select Bank',
								value: undefined
							})
							setUpdatedRemarks(undefined)
							reload()
							showToast({
								type: 'success',
								message: "Bank details updated successfully"
							})
						} else {
							handleError(e)
						}
					})
				}}
			>
				<Select label='Update Bank' placeholder='Select Bank'
					items={allBanks.map((item)=> ({label:<div style={{
					padding: '12px 16px',
					margin: '8px 0',
					border: '1px solid #e0e0e0',
					borderRadius: '8px',
					background: 'linear-gradient(135deg, #ffffff, #f4f7fa)',
					boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
					fontSize: '15px',
					color: '#333',
					transition: 'transform 0.2s ease',
					cursor: 'pointer'
					}}>
					<p style={{ margin: '4px 0', fontWeight: 600, color: '#2c3e50' }}>
						Bank name &nbsp;:  &nbsp;{item.bankName}
					</p>
					<p style={{ margin: '4px 0', color: '#555' }}>
						Account no : &nbsp;&nbsp;{item.account}
					</p>
					<p style={{ margin: '4px 0', color: '#777' }}>
						IFSC Code &nbsp;:  &nbsp;&nbsp;{item.ifsc}
					</p>
					</div>,
					value:item
				}))}
				value={{
					label:updatedBank.value && updatedBank.value.bankName ? updatedBank.value.bankName : 'Select Bank',
					value:updatedBank.value && updatedBank.value.bankName
				}}
				select={(val) => {
					if(verifyOnBankDetailsUpdateByAdmin || approvalStatus())
					{
						setUpdatedBank(val)
					}
					else{
						setLoadingSpiner(true);
						post(`validate/bank`,{
							ifsc:val.value.ifsc,
							account:val.value.account,
							force:true,
							...virtualToggles?{virtual:true}:{}
						},(e,r)=>{
							setLoadingSpiner(false);
							if(r) {
								setUpdatedBank(val)
								showToast({
									type: 'success',
									message: "Bank details are valid"
								})
							}
							else if(e){
								showToast({
									type: 'error',
									message: "Bank details are not valid"
								})
							}
						})
					}
				}}></Select>
				<label style={{marginTop:10}}>Enter Remarks:</label>
				{!verifyOnBankDetailsUpdateByAdmin && !approvalStatus() && (
                    <VirtualAccountToggle
                        checked={virtualToggles}
                        onChange={e => {
                            setVirtualToggles(!virtualToggles);
                        }}
                    />
                )}
				<div><input type='text' value={updatedRemarks ? updatedRemarks : ''} placeholder={'Enter Remarks'} style={{marginTop:10,width:'100%',padding:14,borderRadius:'5%'}} onChange={(e)=>{setUpdatedRemarks(e.target.value)}}/></div>
				{loadingSpiner && (
					<div style={{
					position: 'absolute',
					top: 0, left: 0,
					width: '100%',
					height: '100%',
					background: 'rgba(255,255,255,0.7)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					borderRadius: '8px',
					zIndex: 10
					}}>
						<Spinner radius={36} visible={true} color="var(--primary-color)"/>
					</div>
				)}	
			</Modal>
        </div>
    )
}

export default Index;